__turbopack_context__.v({
  "header": "ItineraryCardHeader-module__AF_-Ea__header",
  "icon": "ItineraryCardHeader-module__AF_-Ea__icon",
  "meta": "ItineraryCardHeader-module__AF_-Ea__meta",
  "title": "ItineraryCardHeader-module__AF_-Ea__title",
});
